<template>
  <div class="phone-input">
    <el-select
      class="phone-input__prefix"
      :class="{ 'phone-input__prefix--focus': isPrefixFocus }"
      ref="select"
      :placeholder="i18n(`entities.phone.placeholders.${fields.prefix.name}`)"
      v-model="model.prefix"
      @change="onPrefixChange"
      @visible-change="onPrefixChange"
      @focus="isPrefixFocus = true"
      @blur="isPrefixFocus = false"
    >
      <el-option :value="undefined">-</el-option>
      <el-option
        v-for="[code, prefix] in Object.entries(phoneCountryPrefixes)"
        :key="code"
        :label="getPrefixOptionLabel(code, prefix)"
        :value="`${prefix}=${code}`"
      />
    </el-select>
    <el-input
      class="phone-input__number"
      :placeholder="i18n(`entities.phone.placeholders.${fields.number.name}`)"
      v-model="model[fields.number.name]"
      prefix-icon="icon-phone"
      @input="onNumberChange"
    />
  </div>
</template>

<script>
import { i18n, i18nExists } from '@shared/i18n';

import { FormSchema } from '@shared/form/form-schema';
import { PhoneModel } from '@shared/model/phone-model';

import phoneCountryPrefixes from '@enums/phoneCountryPrefix.json';

const { fields } = PhoneModel;
const formSchema = new FormSchema([
  fields.prefix,
  fields.number,
]);

export default {
  name: 'phone-input',
  props: {
    value: Object,
  },
  data() {
    return {
      model: {
        prefix: null,
        number: null,
      },
      isPrefixFocus: false,
      fields,
      phoneCountryPrefixes,
      i18n,
    }
  },
  computed: {
    parsedModel() {
      const { prefix, number } = this.model
      return {
        prefix: prefix ? prefix.split('=')[0] : null,
        number,
      }
    },
  },
  created() {
    this.model = formSchema.initialValues(this.value);
  },
  methods: {
    onPrefixChange() {
      this.$refs.select.selectedLabel = this.parsedModel.prefix
      this.onChange()
    },
    onNumberChange() {
      this.onChange()
    },
    onChange() {
      this.$emit('input', Object.assign({}, this.parsedModel))
    },
    getPrefixOptionLabel(code, prefix) {
      const countryLabel = i18nExists(`enumerators.country.${code}`)
        ? i18n(`enumerators.country.${code}`)
        : i18n(`enumerators.phoneAdditionalCountries.${code}`)

      return `${prefix} (${countryLabel})`
    },
  },
  watch: {
    value(val, oldVal) {
      if (!val) return
      const hasChanged = !oldVal || val.prefix !== oldVal.prefix || val.number !== oldVal.number
      if (!hasChanged) return
      this.model = val
    },
  },
}
</script>

<style>
.phone-input {
  --prefix-width: 100px;
}

.phone-input .phone-input__prefix.el-select {
  width: var(--prefix-width);
}

.phone-input .phone-input__prefix--focus.el-select {
  z-index: 2;
}

.phone-input .phone-input__prefix.el-select .el-input__inner {
  border-radius: 20px 0 0 20px;
  text-align: center;
}

.phone-input .phone-input__number.el-input {
  width: calc(100% - var(--prefix-width)) !important;
}

.phone-input .phone-input__number.el-input .el-input__inner {
  border-radius: 0 20px 20px 0;
  margin-left: -1px;
}
</style>
